import { PublicMeetingDetailsResponseType } from '../lib/api';
import { getKvContentKnovioUrl } from '../lib/api/utils';
import { KV_PARAMS } from '../lib/kv-embed/KvEmbedTrackingService';
import useAttendeeToken from './use-attendee-token';
import { Connection } from '../lib/connection/connection';

export type ConnectionPublicDetailsType = PublicMeetingDetailsResponseType;

/*
* Connection method precedence:
* 1 - Attendee level connection
* 1.1 - embedCodeId
* 1.2 - connectionLink
* 2 - Link set for an Attendee
*/

export const openWindow = (url?: string): void => {
  window.open(url ?? '', '_blank');
};

export default function useConnectToPublicMeetingMethod(details: PublicMeetingDetailsResponseType): () => void {
  const attendeeToken = useAttendeeToken();

  return () => {
    if (!details) return;

    const connection = Connection.create(details);

    const { attendeeLink } = details;

    if (connection) {
      if (connection.isKnovioConnectionType()) {
        const url = `${getKvContentKnovioUrl(connection.embedCodeId)}?${KV_PARAMS.KV_ID}=${attendeeToken}`;

        return openWindow(url);
      }

      return openWindow(connection.connectionLink);
    }

    return openWindow(attendeeLink);
  };
}
